import { action } from "typesafe-actions";
import { FilterActionTypes, FilterType, TimelineRangeType } from "./types";
import { ApplicationState } from "..";
import { interpolateSinebow, lch } from "d3";
import { ParsedExport } from "@store/data/types";
import { AppDispatch } from "index";
import { VisTypes } from "@store/options/types";

export function selectCategory(filter: FilterType, id: string) {
  return (dispatch: AppDispatch) => {
    dispatch(action(FilterActionTypes.TOGGLE_ITEM, { filter, id }));
  };
}
export function deselectCategories(filter: FilterType) {
  return (dispatch: AppDispatch) => {
    dispatch(action(FilterActionTypes.DESELECT_ALL, { filter }));
  };
}
export function selectCategories(filter: FilterType) {
  return (dispatch: AppDispatch) => {
    dispatch(action(FilterActionTypes.SELECT_ALL, { filter }));
  };
}

export function setSidebarFilter(types: FilterType[]) {
  return (dispatch: AppDispatch) => {
    dispatch(action(FilterActionTypes.SET_ACTIVE_FILTERS, { active: types }));
  };
}

export function setTimelineSelection(selection: TimelineRangeType) {
  return (dispatch: AppDispatch) => {
    dispatch(action(FilterActionTypes.SET_TIMELINESELECTION, { selection }));
  };
}

export function updateColors(filter: FilterType, array: [string, string][]) {
  return (dispatch: AppDispatch) => {
    // maybe update based on current selected color scheme?
    // only the timeline has different color schemes, so
    dispatch(action(FilterActionTypes.UPDATE_COLOR, { filter, array }));
  };
}

export function updateLocations(array: [string, string][]) {
  return (dispatch: AppDispatch) => {
    dispatch(
      action(FilterActionTypes.UPDATE_COLOR, {
        filter: FilterType.locations,
        array,
      }),
    );
  };
}

export function updateSubcategories() {
  return (dispatch: AppDispatch, getState: () => ApplicationState) => {
    const filter = getState().options.currentVis;
    const result = createSubcategoryList(getState().data.exports)
      .sort((a, b) => b[1] - a[1])
      .map((d, i, arr) => [d[0], getColor(i, arr.length)]);
    dispatch(
      action(FilterActionTypes.UPDATE_SUBCATEGORY, {
        list: result,
        filter: determineCurrentCategory(filter),
      }),
    );
  };
}

export function updateContacts(range: { min: number; max: number }) {
  return (dispatch: AppDispatch) => {
    dispatch(
      action(FilterActionTypes.UPDATE_CONTACT, {
        range,
      }),
    );
  };
}

function getColor(i: number, len: number): string {
  const t = i / len;
  const { h } = lch(interpolateSinebow(i % 2 === 0 ? t + 0.5 : 1 - t));
  return lch(85, 70, h).formatHex();
  //return rgb(interpolateSinebow(44 / (i ) + (i%2))).formatHex();
}

function createSubcategoryList(data: ParsedExport[]): [string, number][] {
  const categories = {} as { [key: string]: number };
  for (const exp of data) {
    for (const file of exp.children) {
      for (const point of file.data) {
        categories[point.subcategory] = (categories[point.subcategory] || 0) + 1;
      }
    }
  }
  return Object.entries(categories);
}

function determineCurrentCategory(currentVis: VisTypes) {
  if (currentVis === VisTypes.Files) return FilterType.fileTypes;
  if (currentVis === VisTypes.Timeline) return FilterType.subcategories;
  return FilterType.categories;
}
